export default [{
  mainButton: {
    name: 'staffFilters',
    label: 'Поиск',
    goTo: '?modal=inputFilterModal~staff',
    tooltip: 'Поиск сотрудников'
  }
}, {
  mainButton: {
    name: 'uploadDownload',
    label: 'Загрузка<br>Выгрузка',
    tooltip: 'Загрузка и выгрузка данных',
    menu: [{
      name: 'download',
      label: 'Скачать отметки сотрудников',
      goTo: '?modal=download-attendanceRecords',
      metrikaIdReach: 'btn_download_attendance_records'
    }, {
      name: 'download',
      label: 'Скачать отчет по переработкам/недоработкам',
      goTo: '?modal=download-reportReworkAndFlaw',
      metrikaIdReach: 'btn_download_report_rework_flaw'
    }]
  }
}];